<template>
	<JBox>
		<template v-if="form">
			<JBox class="s-w-full s-mb-8">
				<label class="s-w-full s-font-bold s-text-gray-500">Name</label>
				<!-- REFACTOR:THEME JTEXT SHOULD BE SPECIFIC VARIANT-->
				<JText class="s-text-gray-500 s-text-sm s-mb-1">This field will not be visible to customers</JText>
				<JInputText v-model="form.name" />
			</JBox>

			<JBox class="s-w-full s-mb-8">
				<label class="s-w-full s-font-bold s-text-gray-500">Description</label>
				<!-- REFACTOR:THEME JTEXT SHOULD BE SPECIFIC VARIANT-->
				<JText class="s-text-gray-500 s-text-sm s-mb-1">This field will not be visible to customers</JText>
				<JInputLongText v-model="form.description" />
			</JBox>

			<!-- Slot -->
			<slot :handleSave="handleSave" :handleCancel="handleCancel" />
		</template>
	</JBox>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			form: {}
		}
	},

	methods: {
		handleSave() {
			this.$emit("input", { ...this.form })
		},

		handleCancel() {
			this.$emit("cancel")
		}
	},

	watch: {
		value: {
			handler(newVal) {
				this.form = { ...newVal }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
